<template>
    <div component="demo">
        <video-player :url="'http://voicecasting.sk/intro/music-tutorial.mp4'" />
    </div>
</template>

<script>
import NavButton from '@/components/.global/NavButton.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import VideoPlayer from '@/components/.global/VideoPlayer.vue';

export default {
    name: 'MusicDatabaseDemo2',

    components: {
        NavButton,
        Mp3Player,
        VideoPlayer,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

#video-player {
    width: 100%;
    height: 100%;
    background-color: black;
    overflow: hidden;
    .radiusBig;
}
</style>
